import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './color-selector.css';
import ColorSelectorEvent from './ColorSelectorEvent';
import ColorButtonEvent from '../../../elements/color-button/ColorButtonEvent';
import '../../../elements/color-button/color-button';

class ColorSelector extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    properties() {
        return {
            colors: [],
            activeColorIndex: 0,
        };
    }

    events() {
        return {
            'color-button': {
                [ColorButtonEvent.COLOR_CLICK_ENABLED]: ev => {
                    this.activeColorIndex = Number.parseInt(ev.currentTarget.dataset.index);
                    this.dispatch(ColorSelectorEvent.COLOR_CLICK, this.activeColorIndex);
                },
            },
        };
    }

    template() {
        return html`
            <div class="colors flex justify-center">
                ${this.colors &&
                    this.colors.map((color, index) => {
                        return html`
                            <color-button
                                class="ml-1 mr-1 block"
                                active="${this.activeColorIndex === index}"
                                data-index="${index}"
                                small="true"
                                colors="${JSON.stringify(color.colors)}"
                            ></color-button>
                        `;
                    })}
            </div>
        `;
    }
}

defineElement('color-selector', ColorSelector);
